<template>
  <section :class="['hero', 'is-hero-bar', isScroll ? 'sticky' : '']">
    <div class="hero-body">
      <div class="columns is-vcentered">
        <div class="column is-narrow is-12-mobile is-4-fullhd">
            <div>
              <span class="subtitle is-spaced"><a @click="goBack" v-text="'< Volver'"> </a></span><span class="title is-2 is-spaced"><slot name="title"/></span>
              <p class="subtitle is-4"><slot name="sub-title"/></p>
            </div>
        </div>
        <div v-if="hasRightVisible" class="column is-12-mobile">
            <slot name="right"/>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'HeroBar',
  data () {
    return {
      isScroll: false
    }
  },
  props: {
    hasRightVisible: {
      type: Boolean,
      default: true
    }
  },
  created () {
    window.addEventListener('scroll', this.handleScroll)
  },
  destroyed () {
    window.removeEventListener('scroll', this.handleScroll)
  },
  methods: {
    handleScroll (event) {
      if (window.scrollY > 0) {
        this.isScroll = true
      } else {
        this.isScroll = false
      }
    },
    goBack () {
      window.history.back()
    }
  }
}
</script>

<style scoped>
  .title{
    margin-bottom: 0px;
  }
</style>
